<template>
  <div class="dialog-button" :class="getClass" @click="handleClick">
    <span class="dialog-button-text">{{ text }}</span>
  </div>
</template>

<script>
import { addGA } from '@/utils/assist'

export default {
  props: {
    text: String,
    // 仅仅判断按钮 type
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getClass () {
      return this.disabled ? 'dialog-button-disabled' : 'dialog-button-enabled'
    }
  },
  methods: {
    handleClick () {
      addGA(`dialog-button-${this.text}`, 'click')
      this.$emit('clickDialogButton')
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-button {
  @include flexrc;
  @include px2res(width, 306);
  @include px2res(height, 93);

  &.dialog-button-enabled {
    /* @include px2res(-webkit-text-stroke-width, 2); */
    /* -webkit-text-stroke-color: #EFF039; */
  }

  &.dialog-button-disabled {
    @include px2res(-webkit-text-stroke-width, 2);
    -webkit-text-stroke-color: #fff;
  }

  .dialog-button-text {
    @include px2res(margin-top, -8);
    /* color: $purchase-button-color; */
    color: #fff;
    @include px2res(font-size, 50);
    font-weight: 300;
    font-family: $main-font-family;
    filter: drop-shadow(1px 0px 0px #4a250f) drop-shadow(-1px 0px 0px #4a250f)
        drop-shadow(0px 1px 0px #4a250f) drop-shadow(0px -1px 0px #4a250f)
        drop-shadow(1px 0px 0px #0b5b9e) drop-shadow(-1px 0px 0px #0b5b9e)
        drop-shadow(0px 1px 0px #0b5b9e) drop-shadow(0px -1px 0px #0b5b9e);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/business-base/dialog-button/index.vue